/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModeCalculTarification } from './ModeCalculTarification';
import {
    ModeCalculTarificationFromJSON,
    ModeCalculTarificationFromJSONTyped,
    ModeCalculTarificationToJSON,
    ModeCalculTarificationToJSONTyped,
} from './ModeCalculTarification';
import type { ModeCalculFraisParc } from './ModeCalculFraisParc';
import {
    ModeCalculFraisParcFromJSON,
    ModeCalculFraisParcFromJSONTyped,
    ModeCalculFraisParcToJSON,
    ModeCalculFraisParcToJSONTyped,
} from './ModeCalculFraisParc';

/**
 * Enregistrement de la configuration parc d'un frais.
 * @export
 * @interface SaveFraisParcConfigCommand
 */
export interface SaveFraisParcConfigCommand {
    /**
     * 
     * @type {ModeCalculFraisParc}
     * @memberof SaveFraisParcConfigCommand
     */
    modeCalcul: ModeCalculFraisParc;
    /**
     * Uniquement en mode UneFoisParParc ; interdit en mode ParBien.
     * @type {number}
     * @memberof SaveFraisParcConfigCommand
     */
    montantParc?: number | null;
    /**
     * 
     * @type {ModeCalculTarification}
     * @memberof SaveFraisParcConfigCommand
     */
    modeMontantParc?: ModeCalculTarification;
}



/**
 * Check if a given object implements the SaveFraisParcConfigCommand interface.
 */
export function instanceOfSaveFraisParcConfigCommand(value: object): value is SaveFraisParcConfigCommand {
    if (!('modeCalcul' in value) || value['modeCalcul'] === undefined) return false;
    return true;
}

export function SaveFraisParcConfigCommandFromJSON(json: any): SaveFraisParcConfigCommand {
    return SaveFraisParcConfigCommandFromJSONTyped(json, false);
}

export function SaveFraisParcConfigCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveFraisParcConfigCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'modeCalcul': ModeCalculFraisParcFromJSON(json['modeCalcul']),
        'montantParc': json['montantParc'] == null ? undefined : json['montantParc'],
        'modeMontantParc': json['modeMontantParc'] == null ? undefined : ModeCalculTarificationFromJSON(json['modeMontantParc']),
    };
}

export function SaveFraisParcConfigCommandToJSON(json: any): SaveFraisParcConfigCommand {
    return SaveFraisParcConfigCommandToJSONTyped(json, false);
}

export function SaveFraisParcConfigCommandToJSONTyped(value?: SaveFraisParcConfigCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'modeCalcul': ModeCalculFraisParcToJSON(value['modeCalcul']),
        'montantParc': value['montantParc'],
        'modeMontantParc': ModeCalculTarificationToJSON(value['modeMontantParc']),
    };
}

